import xlsx, { IColumn, IJsonSheet, ISettings } from "json-as-xlsx";

export function exportExcelExemploGrupoUnidades() {
  const columns: IColumn[] = [];

  columns.push({
    label: "numero",
    value: "",
  });

  columns.push({
    label: "blocoQuadra",
    value: "",
  });

  const settings: ISettings = {
    fileName: `Tabela Exemplo - Grupo de Unidades`,
    extraLength: 3,
    writeOptions: {},
  };

  const sheets: IJsonSheet[] = [];

  sheets.push({
    sheet: `Consumo por unidade`,
    columns: columns,
    content: [{}],
  });

  xlsx(sheets, settings);
}
